import { UseProductAttributesReturnType } from '@common/context/ShopAllContext/hooks';
import React from 'react';

import ProductAttributesForm from './ProductAttributesForm';

interface ShopAllSidebarProps {
  shopAllAttributesForm?: UseProductAttributesReturnType;
  hideForms?: boolean;
}

const ShopAllSidebar: React.FC<ShopAllSidebarProps> = ({ shopAllAttributesForm }) => {
  return (
    <div className="md:pl-52 md:pr-44 text-theme">
      <div className="text-14 text-disabled mb-10" font-customisation="para-text" color-customisation="page-body-text">
        Filter By
      </div>
      <hr className="border-subtheme border-t-2 mb-20 rounded" />
      <ProductAttributesForm shopAllAttributesForm={shopAllAttributesForm} />
    </div>
  );
};

export default ShopAllSidebar;
